export const uniqBy = <T>(array: T[], getKey: (item: T) => number | string): T[] => {
  const seen: { [key: string]: boolean } = {};
  return array.filter((item) => {
    const key = getKey(item);
    // eslint-disable-next-line no-prototype-builtins
    return seen.hasOwnProperty(key) ? false : (seen[key] = true);
  });
};
